
import { FtpUserStatus, FtpUserWithLogs } from '@/services/FtpUser/interfaces';
import { ServerInterface } from '@/services/Server/Interfaces';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { PasswordValidationCallbacks } from "@/services/misc/functions/ValidationFunctions";

@Component({
  mixins: [
    Themeable,
  ]
})
export default class EditFtpUserDialog extends Vue {
  public visible: boolean = true;
  @Prop() public data: {
    ftpUser: FtpUserWithLogs,
    server: ServerInterface,
  };

  public get statusString(): string {
    return FtpUserStatus[this.data.ftpUser.status];
  }

  public password: string = '';
  public passwordRules = [
    ...PasswordValidationCallbacks
  ];

  public saveChanges(): void {
    this.data.ftpUser.password = this.password;
    this.$emit('edit', this.data.ftpUser);
  }

  public destroyComponent(): void {
    this.$emit('close');
  }
}
